import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { scholineApi } from "./api/scholineApi.js";

export const store = configureStore({
  reducer: {
    [scholineApi.reducerPath]: scholineApi.reducer,

  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(scholineApi.middleware);
  },
});

setupListeners(store.dispatch);

export {
  useCreateRegistrationMutation,
  useSubmitResumeMutation,
} from "./api/scholineApi.js";

